import { Card, Skeleton as SkeletonBasic } from '@mantine/core';
import React from 'react';
export default function Skeleton() {
  return(
    <Card p="md" radius="md" style={{ width: '100%' }}>
      <Card.Section p="md" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <SkeletonBasic height={20} width="100%" />
        <SkeletonBasic height={15} mt={16} width="30%" />
        <SkeletonBasic height={15} width="30%" />
        <SkeletonBasic height={15} width="30%" />
        <SkeletonBasic height={15} width="30%" />
        <SkeletonBasic height={15} mt={30} width="100%" />
        <SkeletonBasic height={15} mt={16} width="30%" />
        <SkeletonBasic height={15} width="30%" />
        <SkeletonBasic height={15} width="30%" />
        <SkeletonBasic height={15} width="30%" />
      </Card.Section>
    </Card>
  );
}
